import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha, SxProps, Theme } from '@mui/material/styles';
import { AlertSeverity, severityConfig } from '@/common/components/alert/config.tsx';

export interface AlertProps {
  severity: AlertSeverity;
  title: ReactNode;
  message?: ReactNode;
  secondaryMessage?: ReactNode;
  actions?: ReactNode;
  sx?: SxProps<Theme>;
}

export const Alert = ({ severity, title, message, secondaryMessage, actions, sx }: AlertProps) => {
  const { icon: Icon, color } = severityConfig[severity];

  return (
    <Stack alignItems="center" textAlign="center" gap={2} sx={sx}>
      <Box
        sx={(theme) => ({
          width: 56,
          height: 56,
          borderRadius: '50%',
          backgroundColor: alpha(theme.palette[color].light, 0.1),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        })}
      >
        <Icon color={color} sx={{ fontSize: 32 }} />
      </Box>
      <Stack gap={1}>
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        {message && <Typography variant="body2">{message}</Typography>}
        {secondaryMessage && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {secondaryMessage}
          </Typography>
        )}
      </Stack>
      {actions && <Box sx={{ width: '100%', mt: 1 }}>{actions}</Box>}
    </Stack>
  );
};
